﻿export enum WorkItemDataVersionPreference {
    None,
    PreferSaved,
    PreferSubmitted,
    PreferSavedWhenClaimed
}